import service from '@/utils/axios-v2';

// loads 分享页获取详情v2
export function getLoadDetail(uuid) {
  return service({
    url: `/fleet/dispatch/v2/load/detail_query_share?UUId=${uuid}`,
    method: 'get',
    isNotPrompt: true
  })
}

export function getLoadShareUuid(loadId) {
  return service({
    url: `/fleet/dispatch/v2/load/uuid/get?loadId=${loadId}`,
    method: 'get'
  })
} 

export function getLoadTracking(loadId) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/V3/tracking/get?loadId=${loadId}`,
    method: 'get'
  })
}

export function getTrackingHos(data) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/V3/location/logs`,
    method: 'get',
    params: data,
    isNotPrompt: true
  })
}


/**
 *
 * @load get load list V3
 * @param  params: {
 *   requestType: 'load_list'| 'driver_load_list' | 'load_schedule' | 'unassigned_load'
 *   page,
 *   size
 * }
 */
const BodyCtGetLoadListV3 = {
  load_list: 'listRequest',
  driver_load_list: 'driverLoadListRequest',
  load_schedule: 'scheduleRequest',
  unassigned_load: ''
}
export function getLoadListV3 (params={}, data) {
  params['type'] = 'list';
  data = data ? {[BodyCtGetLoadListV3[params.requestType]]: data}: ''
  return service({
    url: `/fleet/dispatch/v3/load/list/query`,
    method: 'post',
    data: data,
    params: params,
    headers: {
      'portal-token': true,
    },
  })
}
